var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.90332C18 7.31202 17.3679 5.7859 16.2426 4.66068C15.1174 3.53546 13.5913 2.90332 12 2.90332C10.4087 2.90332 8.88258 3.53546 7.75736 4.66068C6.63214 5.7859 6 7.31202 6 8.90332C6 15.9033 3 17.9033 3 17.9033H21C21 17.9033 18 15.9033 18 8.90332Z",
    stroke: "#424952",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 21.9033C13.5542 22.2064 13.3019 22.458 12.9982 22.6329C12.6946 22.8077 12.3504 22.8998 12 22.8998C11.6496 22.8998 11.3054 22.8077 11.0018 22.6329C10.6982 22.458 10.4458 22.2064 10.27 21.9033",
    stroke: "#424952",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.42228208b76aa188ee28b481c3be57e4.svg";
export { ForwardRef as ReactComponent };